/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { BackgroundContainer, ResponsiveContainer, SectionContainer, SectionHeading } from "@components/elements";
import { PluginListTableSectionFragment } from "@cosmos/hygraph-schema";
import { VStack } from "@panda/jsx";
import { PluginListTable } from "./PluginListTable.organism";

export interface PluginListTableSectionProps extends PluginListTableSectionFragment {
	className?: string;
}

export const PluginListTableSection = ({
	config,
	tableItems,
}: PluginListTableSectionProps): React.JSX.Element | null => {
	const validHeading = Boolean(config?.heading?.title || config?.heading?.desc);

	if (!validHeading && !tableItems?.length) return null;

	return (
		<BackgroundContainer
			bgAnimation={config?.backgroundAnimation}
			bgImageAsset={config?.backgroundImage}
			bgFullHeight={config?.backgroundFullHeight}
			edsBackgroundColor={config?.edsBackgroundColor}
		>
			<ResponsiveContainer>
				<SectionContainer disablePaddingBlockEnd={!!config?.disablePaddingBottom}>
					<VStack alignItems="stretch" gap="eds.dimension.48" className="plugin-list-table-section">
						{validHeading ? <SectionHeading {...config?.heading} /> : null}
						{tableItems?.length ? <PluginListTable items={tableItems} /> : null}
					</VStack>
				</SectionContainer>
			</ResponsiveContainer>
		</BackgroundContainer>
	);
};
